import { createDynamicThunk } from ".";

/**
 * Fetch dashboard details
 */
export const fetchDashboardThunk = createDynamicThunk({
  typePrefix: "dashboard/fetchDashboardThunk",
  endpoint: "/dashboardDetails",
  method: "POST",
  refreshList: false,
  validatePayload: (payload) => {
    if (!payload?.filterValues) {
      throw new Error("filterValues is required for dashboard API");
    }
  },
});

/**
 * Fetch users (QC, TL, ATL, Auditor)
 */
export const fetchDashboardUsersThunk = createDynamicThunk({
  typePrefix: "dashboard/fetchDashboardUsersThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Fetch departments
 */
export const fetchDepartmentsThunk = createDynamicThunk({
  typePrefix: "fetchDepartmentsThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const fetchClientsAsDropdownThunk = createDynamicThunk({
  typePrefix: "fetchClientsAsDropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const fetchAgentClientsAsDropdownThunk = createDynamicThunk({
  typePrefix: "fetchAgentClientsAsDropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const fetchDepartmentAuditFormsThunk = createDynamicThunk({
  typePrefix: "fetchDepartmentAuditFormsThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const fetchClientAgentsThunk = createDynamicThunk({
  typePrefix: "fetchClientAgentsThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const fetchClientAgentsAsDropdownThunk = createDynamicThunk({
  typePrefix: "fetchClientAgentsAsDropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const fetchDepartmentAuditFormsAsropdownThunk = createDynamicThunk({
  typePrefix: "fetchDepartmentAuditFormsAsropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const fetchDepartmentClientsAsropdownThunk = createDynamicThunk({
  typePrefix: "fetchDepartmentClientsAsropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});
